// const OurLeadersipTeam = () => {
//   const teamMembers = [
//     {
//       name: "Maj Gen Mohammad Kamrul Hasan, SGP, SUP, ndc, hdmc, psc",
//       title: "President",
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754892864/TF00001_passport-min_f4iuzp.jpg",
//     },
//     {
//       name: "Brig Gen Emranul Hasan, BGMS",
//       title: "Vice President",
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113122/WhatsApp_Image_2025-08-14_at_1.05.08_AM_zsobp3.jpg",
//     },
//     {
//       name: "Col Muhammad Rubayat Zamil, BSP",
//       title: "Golf Capt",
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113121/WhatsApp_Image_2025-08-14_at_1.05.06_AM_ma8v7s.jpg",
//     },
//     {
//       name: "Lt Col Arif Billah, psc",
//       title: "Member Secretary",
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113122/WhatsApp_Image_2025-08-14_at_1.05.011_AM_uiepq2.jpg",
//     },
//     {
//       name: "Maj Md Faysal Hasan Khan, SUP",
//       title: "Asst Member Secretary",
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113121/WhatsApp_Image_2025-08-14_at_1.05.07_AM_l3579p.jpg",
//     },
//     {
//       name: "Capt Nasreen Haque Boby",
//       title: "Lady Golf Capt",
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755166080/WhatsApp_Image_2025-08-14_at_4.06.11_PM_ni5t14.jpg",
//     },
//   ];

import { useEffect, useRef } from "react";

//   const [president, ...otherMembers] = teamMembers;

//   return (
//     <div>
//       <section className="py-5 px-4 md:px-20 bg-gray-50">
//         <h2 className="text-2xl font-bold mb-5 text-center uppercase">
//           RGCC Leadership Team
//         </h2>

//         {/* President Card - Larger and centered at top */}
//         <div className="flex justify-center mb-5">
//           <div className="text-center border rounded-[5px] p-6 max-w-md w-full shadow-lg bg-white">
//             <img
//               src={president.image}
//               alt={president.name}
//               className="w-48 h-48 mx-auto rounded-full object-cover mb-6 border-4 border-gold-500"
//             />
//             <h4 className="font-bold text-lg">{president.name}</h4>
//             <p className="text-md text-gray-600 font-semibold">
//               {president.title}
//             </p>
//           </div>
//         </div>

//         {/* Other Team Members */}
//         <div className="grid sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10 overflow-x-scroll">
//           {otherMembers.map((member, i) => (
//             <div
//               key={i}
//               className="text-center border rounded-[5px] p-[5px] hover:shadow-md transition-shadow bg-white"
//             >
//               <img
//                 src={member.image}
//                 alt={member.name}
//                 className="w-32 h-32 mx-auto rounded-full object-cover mb-4"
//               />
//               <h4 className="font-bold">{member.name}</h4>
//               <p className="text-sm text-gray-600">{member.title}</p>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default OurLeadersipTeam;

const OurLeadershipTeam = () => {
  const teamMembers = [
    {
      name: "Maj Gen Mohammad Kamrul Hasan, SGP, SUP, ndc, hdmc, psc",
      title: "President",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754892864/TF00001_passport-min_f4iuzp.jpg",
    },
    {
      name: "Brig Gen Emranul Hasan, BGMS",
      title: "Vice President",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113122/WhatsApp_Image_2025-08-14_at_1.05.08_AM_zsobp3.jpg",
    },
    {
      name: "Col Muhammad Rubayat Zamil, BSP",
      title: "Golf Capt",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113121/WhatsApp_Image_2025-08-14_at_1.05.06_AM_ma8v7s.jpg",
    },
    {
      name: "Lt Col Arif Billah, psc",
      title: "Member Secretary",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113122/WhatsApp_Image_2025-08-14_at_1.05.011_AM_uiepq2.jpg",
    },
    {
      name: "Maj Md Faysal Hasan Khan, SUP",
      title: "Asst Member Secretary",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755113121/WhatsApp_Image_2025-08-14_at_1.05.07_AM_l3579p.jpg",
    },
    {
      name: "Capt Nasreen Haque Boby",
      title: "Lady Golf Capt",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755166080/WhatsApp_Image_2025-08-14_at_4.06.11_PM_ni5t14.jpg",
    },
  ];

  const leadershipRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (leadershipRef.current) {
        leadershipRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
  });

  const [president, ...otherMembers] = teamMembers;

  return (
    <div className="bg-gradient-to-b from-gray-50 to-white">
      <section className="py-16 px-4 md:px-8 lg:px-16 xl:px-20">
        {/* Header Section */}
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-lime-100 to-lime-200 rounded-full mb-6 shadow-lg">
            <svg
              className="w-10 h-10 text-lime-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-gray-900 to-lime-800 bg-clip-text text-transparent mb-4">
            RGCC Leadership Team
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Meet the distinguished leaders who guide the Rangpur Golf and
            Country Club with expertise and dedication
          </p>
        </div>

        {/* President Card - Featured */}
        <div className="flex justify-center mb-20">
          <div className="relative bg-gradient-to-br from-white to-gray-50 rounded-2xl p-8 max-w-2xl w-full shadow-2xl border border-gray-200 transform hover:scale-[1.02] transition-all duration-300">
            {/* Decorative elements */}
            <div className="absolute -top-3 -right-3 w-16 h-16 bg-gradient-to-br from-lime-500 to-lime-600 rounded-full opacity-20"></div>
            <div className="absolute -bottom-3 -left-3 w-20 h-20 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full opacity-20"></div>

            <div ref={leadershipRef} className="relative text-center">
              <div className="relative mx-auto mb-8">
                <div className="relative w-56 h-56 mx-auto">
                  <div className="absolute inset-0 bg-gradient-to-br from-lime-500 to-lime-600 rounded-full blur-xl opacity-30"></div>
                  <img
                    src={president.image}
                    alt={president.name}
                    className="w-full h-full rounded-full object-cover border-4 border-white shadow-2xl relative z-10"
                  />
                </div>
                {/* Position badge positioned below image */}
                <div className="mt-6">
                  <div className="inline-flex items-center bg-gradient-to-r from-lime-500 to-lime-600 text-white px-6 py-2 rounded-full text-lg font-semibold shadow-lg">
                    <svg
                      className="w-5 h-5 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
                      />
                    </svg>
                    <span>{president.title}</span>
                  </div>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-6 px-4 leading-tight">
                {president.name}
              </h3>

              <p className="text-gray-600 text-sm max-w-lg mx-auto">
                Leading with vision and commitment to excellence
              </p>
            </div>
          </div>
        </div>

        {/* Leadership Team Grid */}
        <div className="mb-12">
          <div className="flex items-center mb-8">
            <div className="w-2 h-10 bg-gradient-to-b from-lime-500 to-lime-600 rounded-full mr-4"></div>
            <h3 className="text-2xl font-bold text-gray-900">
              Executive Committee
            </h3>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {otherMembers.map((member, index) => (
              <div
                key={index}
                className="group relative bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-hidden"
              >
                {/* Background decoration */}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-lime-500 to-lime-600"></div>

                <div className="relative text-center">
                  {/* Image Container */}
                  <div className="relative mb-8">
                    <div className="relative w-40 h-40 mx-auto">
                      <div className="absolute inset-0 bg-gradient-to-br from-lime-500 to-lime-600 rounded-full blur-lg opacity-20 group-hover:opacity-30 transition-opacity duration-300"></div>
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full rounded-full object-cover border-4 border-white shadow-xl relative z-10 group-hover:scale-105 transition-transform duration-300"
                      />
                    </div>

                    {/* Role Badge - Positioned below image with margin */}
                    <div className="mt-6">
                      <div className="inline-flex items-center bg-gradient-to-r from-gray-800 to-gray-900 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-md">
                        <svg
                          className="w-4 h-4 mr-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                          />
                        </svg>
                        <span>{member.title}</span>
                      </div>
                    </div>
                  </div>

                  {/* Name */}
                  <h4 className="font-bold text-lg text-gray-900 mb-4 line-clamp-2 leading-tight min-h-[3.5rem]">
                    {member.name}
                  </h4>

                  {/* Additional Info */}
                  <div className="mt-4 pt-4 border-t border-gray-100">
                    <div className="inline-flex items-center text-gray-600 text-sm">
                      <svg
                        className="w-4 h-4 mr-2 text-lime-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 21v-2a4 4 0 00-4-4H9a4 4 0 00-4 4v2"
                        />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                      <span>RGCC Leadership</span>
                    </div>
                  </div>
                </div>

                {/* Hover Effect Border */}
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-lime-200 rounded-xl transition-all duration-300 pointer-events-none"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer Note */}
        <div className="max-w-3xl mx-auto text-center pt-12 mt-12 border-t border-gray-200">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-lime-50 to-lime-100 rounded-full mb-4">
            <svg
              className="w-8 h-8 text-lime-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
          </div>
          <p className="text-gray-600 text-lg italic max-w-2xl mx-auto">
            "Leadership is not about being in charge. It's about taking care of
            those in your charge."
          </p>
          <p className="text-gray-500 text-sm mt-4">
            - RGCC Leadership Philosophy
          </p>
        </div>
      </section>
    </div>
  );
};

export default OurLeadershipTeam;
